import { localeOption } from "primereact/api"
import { locale } from "../utilities/locale/locale"

const localeText = (key) => {
  return localeOption(key, locale)
}

export default localeText
